// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3d8b5740","455":"06cdcc2a","977":"a4007424"}[chunkId] + ".chunk.js";
};